import { type ElementType } from 'react';
import classNames from 'classnames';
import styles from './Skeleton.module.scss';

export interface SkeletonProps {
  className?: string;
  count?: number;
  tag?: keyof HTMLElementTagNameMap;
}

const Skeleton = ({
  count = 1,
  className,
  tag = 'div',
  ...rest
}: SkeletonProps) => {
  const Tag = tag as ElementType;

  return (
    <>
      {Array.from(Array(count).keys()).map((index) => (
        <Tag
          key={`skeleton-${index}`}
          className={classNames(styles.default, className)}
          aria-hidden="true"
          {...rest}
        />
      ))}
    </>
  );
};

export default Skeleton;
